"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idb_1 = require("../idb");
var keys_1 = require("./keys");
var operations_1 = require("./operations");
var config_1 = require("../config");
var utils_1 = require("../utils");
var base_1 = require("../keystore/base");
var types_1 = require("../types");
var RSAKeyStore = /** @class */ (function (_super) {
    __extends(RSAKeyStore, _super);
    function RSAKeyStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RSAKeyStore.init = function (maybeCfg) {
        return __awaiter(this, void 0, void 0, function () {
            var cfg, rsaSize, hashAlg, storeName, readKeyName, writeKeyName, store;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cfg = config_1.default.normalize(__assign(__assign({}, (maybeCfg || {})), { type: types_1.CryptoSystem.RSA }));
                        rsaSize = cfg.rsaSize, hashAlg = cfg.hashAlg, storeName = cfg.storeName, readKeyName = cfg.readKeyName, writeKeyName = cfg.writeKeyName;
                        store = idb_1.default.createStore(storeName);
                        return [4 /*yield*/, idb_1.default.createIfDoesNotExist(readKeyName, function () { return (keys_1.default.makeKeypair(rsaSize, hashAlg, types_1.KeyUse.Read)); }, store)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, idb_1.default.createIfDoesNotExist(writeKeyName, function () { return (keys_1.default.makeKeypair(rsaSize, hashAlg, types_1.KeyUse.Write)); }, store)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, new RSAKeyStore(cfg, store)];
                }
            });
        });
    };
    RSAKeyStore.prototype.sign = function (msg, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, writeKey, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        return [4 /*yield*/, this.writeKey()];
                    case 1:
                        writeKey = _c.sent();
                        _b = (_a = utils_1.default).arrBufToBase64;
                        return [4 /*yield*/, operations_1.default.sign(msg, writeKey.privateKey, mergedCfg.charSize)];
                    case 2: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    RSAKeyStore.prototype.verify = function (msg, sig, publicKey, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg;
            return __generator(this, function (_a) {
                mergedCfg = config_1.default.merge(this.cfg, cfg);
                return [2 /*return*/, operations_1.default.verify(msg, sig, publicKey, mergedCfg.charSize, mergedCfg.hashAlg)];
            });
        });
    };
    RSAKeyStore.prototype.encrypt = function (msg, publicKey, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        _b = (_a = utils_1.default).arrBufToBase64;
                        return [4 /*yield*/, operations_1.default.encrypt(msg, publicKey, mergedCfg.charSize, mergedCfg.hashAlg)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    RSAKeyStore.prototype.decrypt = function (cipherText, publicKey, // unused param so that keystore interfaces match
    cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var readKey, mergedCfg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.readKey()];
                    case 1:
                        readKey = _c.sent();
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        _b = (_a = utils_1.default).arrBufToStr;
                        return [4 /*yield*/, operations_1.default.decrypt(cipherText, readKey.privateKey)];
                    case 2: return [2 /*return*/, _b.apply(_a, [_c.sent(),
                            mergedCfg.charSize])];
                }
            });
        });
    };
    RSAKeyStore.prototype.publicReadKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var readKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readKey()];
                    case 1:
                        readKey = _a.sent();
                        return [2 /*return*/, operations_1.default.getPublicKey(readKey)];
                }
            });
        });
    };
    RSAKeyStore.prototype.publicWriteKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var writeKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeKey()];
                    case 1:
                        writeKey = _a.sent();
                        return [2 /*return*/, operations_1.default.getPublicKey(writeKey)];
                }
            });
        });
    };
    return RSAKeyStore;
}(base_1.default));
exports.RSAKeyStore = RSAKeyStore;
exports.default = RSAKeyStore;
//# sourceMappingURL=keystore.js.map